const SystemControlsPage = () => {
    return (
        <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-200">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">System Controls</h1>
            <p className="text-gray-600 dark:text-gray-400">Advanced system controls.</p>
        </div>
    );
};

export default SystemControlsPage;
